export default "* Blåmusling\n* Østers\n* Bløddyr\n* Råvarer";